export const colorPickTypeName = "palette";
